import React, { memo } from 'react';
import { Stack, Typography, Card, Alert } from 'investira.react.components';

const AvaliacoesHighlights = memo(() => {
  const NOTA = 3.5;

  return (
    <>
      {process.env.REACT_APP_ENV !== 'prd' && (
        <Stack mb={2}>
          <Alert severity="warning">
            Questionário do gestor:{' '}
            <Typography
              component="a"
              variant="body2"
              color="textPrimary"
              target="_blank"
              href="https://apphmg.investira.biz/avaliacao-gestor/6d9c7884e5110addd38cdeb3ef2a0aab/gestor/6d9c7884e5110addd38cdeb3ef2a0aab">
              <b>Acessar</b>
            </Typography>
          </Alert>
        </Stack>
      )}

      <Stack sx={{ gap: 1, flex: 1, mb: 2 }} direction>
        <Stack gap={1} flex={1}>
          <Card
            sx={{
              flex: 1,
              display: 'flex',
              minHeight: 0
            }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Total de Avaliações
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>3</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flex={1}>
          <Card
            sx={{
              flex: 1,
              display: 'flex',
              minHeight: 0
            }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Aguardando respostas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>1</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
        <Stack gap={1} flex={1}>
          <Card
            sx={{
              flex: 1,
              display: 'flex',
              minHeight: 0
            }}>
            <Stack p={2} justifyContent="space-between">
              <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
                Concluídas
              </Typography>
              <Stack direction="column" justifyContent="flex-end">
                <Stack>
                  <Typography variant="h5" color="textPrimary">
                    <b>1</b>
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Card>
        </Stack>
      </Stack>
    </>
  );
});

export default AvaliacoesHighlights;
